<template>
    <!-- 选择图片 -->
    <div class="Minister-top information">
        <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">安全图片</div>
        </div>
        <div class="information_content" style="margin-bottom: 20px">
            <div class="mB-20">
                <el-button @click="delAllImg">清除图片</el-button>
            </div>
            <div class="d-f ta-c">
                <div v-for="(locator, index) in imageList" :key="locator">
                    <!-- <el-upload :file-list="fileList[locator] || []" :action="upload_url" list-type="picture-card"
                        accept="image/gif, image/jpeg, image/tiff, image/png" :auto-upload="true" :limit="1"
                        :class="{ hide: hideUpload[index] }" :http-request="handleFileUpload"
                        :before-upload="(file) => { return beforeUploadFile(file, index) }"
                        :on-remove="(file, fileList) => { return handleRemove(file, fileList, index) }"
                        :on-success="(response, file, fileList) => { return beforeUploadFileSuccess(response, file, fileList, index) }"
                        :on-preview="handlePictureCardPreview">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload> -->
                    <el-upload :file-list="fileList[locator] || []" :action="upload_url" list-type="picture-card"
                        accept="image/gif, image/jpeg, image/tiff, image/png" :limit="imageList.length"
                        :class="{ hide: hideUpload[index] }"
                        :on-success="(response, file, fileList) => { return beforeUploadFile(response, file, fileList, index) }"
                        :on-remove="(file, fileList) => { return handleRemove(file, fileList, index) }"
                        :on-preview="handlePictureCardPreview" :headers="customHeaders">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <div>{{ imageText[index].titleChinese }}</div>
                </div>
            </div>
            <div class="mT-20">
                图片建议 : 商品至少占用图片<span class="red"> 85% </span>的篇幅。图片只能展示出售的商品，可少量包含或不包含其他道具；主图必须为纯白色背景，不能包含其他搭配品；图片尺寸不得小于
                <span class="red">500*1000</span>，不超过 <span class="red">10000*10000</span>；支持 <span
                    class="red">JPEG、TIFF 和 GIF</span> 格式。
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" top="5vh" :modal="false">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <xuanze-img v-model="xuanzeShow" :img-list="imgSelectList" @confirm="onConfirmByXuanzeImg"></xuanze-img>
    </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
import XuanzeImg from "./xuanzeImg.vue";
export default {
    components: {
        XuanzeImg
    },
    data() {
        return {
            dialogVisible: false,
            xuanzeShow: false,
            dialogImageUrl: '',
            imgSelectList: [],
            fileList: {},
            imageList: [],
            imageText: [],
            hideUpload: [],
            upload_url: Baseurl + "xgImage/uploadImage",
            customHeaders: { token: localStorage.getItem("token") },
            deleteFiles: []
        };
    },
    props: {
        publishInfo: {
            type: Object,
            default: () => ({})
        },
        isChakan: {
            type: Boolean,
            default: false,
        },
        system: {
            type: Number,
            default: 5,
        },
    },
    mounted() {
        this.setFileList()
    },
    methods: {
        getData() {
            // 返回所有当前 data
            return { ...this.$data };
        },
        resetData() {
            // 用 Object.assign 替换 this 上的数据为初始状态
            Object.assign(this.$data, this.$options.data.call(this));
        },
        selectOnePicture() {
            this.xuanzeShow = true
        },
        onConfirmByXuanzeImg(img) {
            console.log(img);
            let imageLocators = null;
            for (let index = 0; index < this.imageList.length; index++) {
                imageLocators = this.imageList[index]
                this.fileList[imageLocators] = []
                this.hideUpload[index] = false
            }
            for (let index = 0; index < img.length; index++) {
                imageLocators = this.imageList[index]
                if (this.fileList[imageLocators].length == 0) {
                    this.fileList[imageLocators].push({
                        name: imageLocators,
                        url: img[index]
                    })
                    this.hideUpload[index] = true
                }
            }
        },
        fileListInit() {
            this.hideUpload = []
            let imageLocators = null;
            for (let index = 0; index < this.imageList.length; index++) {
                this.hideUpload.push(false)
                imageLocators = this.imageList[index]
                this.fileList[imageLocators] = [];
            }
        },
        setFileList() {
            this.fileList = {}
            this.fileListInit()
            this.fileList = {
                "image_locator_ps01": [],
                "image_locator_ps02": [],
                "image_locator_ps03": [],
                "image_locator_ps04": [],
                "image_locator_ps05": [],
                "image_locator_ps06": []
            }
        },
        beforeUploadFile(response, file, fileList, index) {
            this.hideUpload[index] = true
            this.fileList[this.imageList[index]] = [{ name: file.name, url: file.response.data }]
        },
        handleRemove(file, fileList, index) {
            // 这里处理移除图片的逻辑
            this.$nextTick(() => {
                this.hideUpload[index] = false
                this.fileList[this.imageList[index]] = []
                let deleteImage = (file.url.lastIndexOf('/') + 1)
                deleteImage = file.url.substring(deleteImage, file.url.length)
                this.deleteFiles.push(deleteImage)
                this.deleteFiles = []
            })
        },
        handlePictureCardPreview(file) {
            this.dialogVisible = true
            this.dialogImageUrl = file.url
        },
        // 清除所有图片
        delAllImg() {
            this.fileListInit()
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../../../AllegroProductAllegro/ozon.less";
@import '../../../../style/common.css';

.red {
    color: red;
}

.select {
    width: 40px;
    line-height: 30px;
    height: 30px;
    border-radius: 10px;
    position: absolute;
    top: 0;
    left: 110px;
    background-color: rgb(42, 250, 42);
    box-shadow: 0px 2px 7px 0px rgba(85, 110, 97, 0.35);
}

.hide /deep/ .el-upload--picture-card {
    display: none;
}

::v-deep .el-upload-list__item {
    transition: none !important;
}
</style>
